import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { isAdminModernExperienceEnabled } from '@thoughtspot/session-service';
import { isOktaEnabled } from '@thoughtspot/system-config-service';
import React, { Suspense } from 'react';
import { BasePageContext } from "../../contexts/basepage-context";
import { Vertical } from '../../utils/layouts';
import { EmailCustomizations } from '../application-settings/email-customizations';
import { FeatureManagementContainer, HelpCustomization, } from '../application-settings/index';
import { ActiveDirectory } from '../authentication/active-directory/active-directory.container';
import { InternalAuth } from '../authentication/internal-auth/internal-auth.container';
import { MFA } from '../authentication/mfa/mfa.container';
import { Provisioning } from '../authentication/provisioning/provisioning.container';
import { SAMLContainer } from '../authentication/saml';
import { ChartCustomization } from '../chart-customization';
import { CsvUpload } from '../csv-upload/index';
import { HomePageDiscovery } from '../home-page-discovery';
import LiveboardEmbedCustom from '../liveboard-visual-embed/liveboard-embed-custom.container';
import { ApplicationSettingsContainer } from '../modern-experience/application-settings/application-settings.container';
import { CustomizationsContainer } from '../modern-experience/customizations';
import { OrgManagementContainer } from '../modern-experience/org-management';
import { UserManagementContainer } from '../modern-experience/user-management';
import { Org } from '../orgs/pages/org/index.container';
import { SamlContainer } from '../saml/saml-container/saml.container';
import { Settings } from '../settings';
import { Security, Smtp } from '../system';
import { Alert } from '../system/alert';
import { BackupStorage } from '../system/backup-storage';
import { Cluster } from '../system/cluster-status';
import { ScheduledMaintenance } from '../system/scheduled-maintenance';
import { Table } from '../system/table-status';
import { UserAgreement } from '../system/user-agreement';
import { Groups } from '../user-management/groups';
import { Roles } from '../user-management/roles';
import { Users } from '../user-management/users';
import { Variables } from '../variables/variables.container';
import { VersionControlSystem } from '../version-control-system/index';
import styles from './right-panel.module.scss';
const StyleCustomizationContainer = React.memo(({ orgViewModeType }) => {
    const { styleComponents } = BasePageContext();
    const { StyleComponentsContainer } = styleComponents || {};
    if (!StyleComponentsContainer) {
        return (React.createElement(LoadingIndicator, null,
            React.createElement(React.Fragment, null)));
    }
    return (React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, null,
            React.createElement(React.Fragment, null)) },
        React.createElement(StyleComponentsContainer, { orgViewModeType: orgViewModeType })));
});
const HomePageDiscoveryContainer = React.memo(({ orgViewModeType }) => {
    const { homeModuleCustomizationContainer } = BasePageContext();
    if (!homeModuleCustomizationContainer) {
        return (React.createElement(LoadingIndicator, null,
            React.createElement(React.Fragment, null)));
    }
    return (React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, null,
            React.createElement(React.Fragment, null)) },
        React.createElement(HomePageDiscovery, { orgViewModeType: orgViewModeType })));
});
export const RightPanel = ({ screenID, currentOrgId, selectedOrgType, }) => {
    let screenComponentConfig = {
        'settings-security': Security,
        'settings-ssl': Security,
        'settings-rev-ssh': Security,
        'settings-smtp': Smtp,
        'backup-storage': BackupStorage,
        'scheduled-maintenance': ScheduledMaintenance,
        'authentication-saml': isOktaEnabled() ? SamlContainer : SAMLContainer,
        'authentication-mfa': MFA,
        'authentication-provisioning': Provisioning,
        'authentication-active-directory': ActiveDirectory,
        'authentication-local': InternalAuth,
        'settings-help-customization': HelpCustomization,
        'email-customizations': EmailCustomizations,
        'org-management-organizations': isAdminModernExperienceEnabled()
            ? OrgManagementContainer
            : Org,
        'user-agreement': UserAgreement,
        'chart-customization': ChartCustomization,
        'csv-upload': CsvUpload,
        'application-settings': ApplicationSettingsContainer,
        'feature-management': FeatureManagementContainer,
        'user-management-roles': Roles,
        'version-control-system': VersionControlSystem,
        'system-alerts': Alert,
        'system-cluster-details': Cluster,
        'system-table-status': Table,
        'user-management-users': Users,
        'user-management-groups': Groups,
        'modern-user-management': UserManagementContainer,
        'modern-org-management': OrgManagementContainer,
        'homepage-and-discovery': HomePageDiscoveryContainer,
        variables: Variables,
    };
    const { teamComponents } = BasePageContext();
    screenComponentConfig = {
        ...screenComponentConfig,
        pricing: teamComponents.PlanOptions,
        'manage-subscription': teamComponents.ManageSubscription,
        'data-usage': teamComponents.DataRowUsage,
        'settings-style-customization-react': isAdminModernExperienceEnabled()
            ? CustomizationsContainer
            : StyleCustomizationContainer,
    };
    const renderComponent = () => {
        if (screenID.indexOf('tscli-ui') >= 0) {
            return (React.createElement(Settings, { id: screenID.split('tscli-ui-')[1], currentOrgId: currentOrgId }));
        }
        if (screenID.indexOf('visual-embed-liveboard') >= 0) {
            return React.createElement(LiveboardEmbedCustom, { key: screenID, Id: screenID });
        }
        if (screenComponentConfig[screenID]) {
            const FeatureComponent = screenComponentConfig[screenID];
            return (React.createElement(FeatureComponent, { currentOrgId: currentOrgId, orgViewModeType: selectedOrgType }));
        }
        return React.createElement(React.Fragment, null);
    };
    return (React.createElement(Vertical, { className: styles.container }, renderComponent()));
};
//# sourceMappingURL=right-panel.container.js.map